import templateUrl from "emun.order/order-details-lines.htm";

export default () => ({ templateUrl });
